<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="80px" size="mini" style="width: 100%;">
      <div class="formItemBox">
        <el-form-item label="状态:">
          <el-select  v-model="searchForm.planStatus" filterable placeholder="请选择">
            <el-option  label="全部" value="" ></el-option>
              <el-option  label="待编写" value="0" ></el-option>
              <el-option  label="待提交" value="1" ></el-option>
              <el-option  label="待审核" value="2" ></el-option>
              <el-option  label="审核驳回" value="3" ></el-option>
              <el-option  label="审核通过" value="4" ></el-option>
            </el-select>
        </el-form-item>
         <el-form-item label="编制时间:" prop="createTime">
          <el-date-picker
            v-model="searchForm.createTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
      </div>
       <div class="searchBtnBox" style="margin: 0;">
         <el-form-item  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item >
         <el-form-item >
           <el-button type="primary" @click="resetForm('searchForm')">重置</el-button>
         </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
   <div class="table" :style="{height:h}">
     <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  height="100%" style="width: 100%" center border>
       <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column width="130" label="操作">
          <template slot-scope="scope">
            <div>
              <span style="display: inline-block;margin-left: 8px;" v-if="orgSubCode==scope.row.createSubdepartmentCode">
                <el-button type="text" size="mini" v-if="scope.row.planStatus=='0'&&btnFlg[1]" @click="bianXieFn(scope.row)">编写</el-button>
                <el-button type="text" v-if="(scope.row.planStatus==1||scope.row.planStatus==3)&&btnFlg[2]" size="mini" @click="bianXieFn(scope.row)">修改</el-button>
                <el-button type="text" v-if="scope.row.planStatus==1&&btnFlg[3]" size="mini" @click="tijiaoFn(scope.row)">提交审核</el-button>
                <el-button type="text" v-if="(scope.row.planStatus==2&&scope.row.auditUserId == userCode)&&btnFlg[4]"  size="mini" @click="shenheFn(scope.row)">审核</el-button>
                <el-button type="text" size="mini"  v-if="scope.row.planStatus=='4'&&btnFlg[6]" @click="shijishouzhiFn(scope.row)">实际收支</el-button>
                <el-button type="text" size="mini" v-if="scope.row.planStatus=='4' && btnFlg[7]" @click="chexiaoFn(scope.row)" >撤销</el-button>
              </span>
              <el-button type="text" size="mini" v-if="scope.row.planStatus!='0'&&btnFlg[5]" :disabled='isDisable' @click="daochuFn(scope.row)">导出详情</el-button>
              <!-- <el-button type="text" size="mini"  v-if="scope.row.planStatus=='4'&&btnFlg[6]" @click="tiaozhengFn(scope.row)">调整</el-button> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createDepartmentName" width="" label="部门"></el-table-column>
        <el-table-column prop="planStatus" width="" label="状态">
          <template scope="scope">
            <div>
              <!-- 0：待编写 1：待提交 2：待审核（审核中） 3：审核驳回 4：审核通过 -->
              <span style="color: #D51212;" v-if="scope.row.planStatus==0">待编写</span>
              <span style="color: #E99D42;" v-if="scope.row.planStatus==1">待提交</span>
              <span style="color: #03aadf;" v-if="scope.row.planStatus==2">待审核</span>
              <span style="color: #f52020;" v-if="scope.row.planStatus==3">审核驳回</span>
              <span style="color: #81B337;" v-if="scope.row.planStatus==4">审核通过</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="weekSubmitPlanDate" width="170" label="最晚提交时间" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column prop="yearMonthDate" width="80" label="年月"></el-table-column>
        <el-table-column prop="yearMonthDate" width="170" label="周期">
          <template scope="scope">
            <el-button  type="text" size="mini" @click="detailFn(scope.row)">
              {{scope.row.cycleStartDate}}~{{scope.row.cycleEndDate}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="predictedIncome" min-width="80" label="计划收入(万元)"></el-table-column>
        <el-table-column prop="predictedExpense" min-width="80" label="计划支出(万元)"></el-table-column>
        <el-table-column prop="" min-width="80" label="收支差异(万元)">
          <template scope="scope">
            <div>
              {{toFixed(scope.row.predictedIncome-scope.row.predictedExpense,4)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="actualIncome" min-width="80" label="实际收入(万元)"></el-table-column>
        <el-table-column prop="actualExpense" min-width="80" label="实际支出(万元)"></el-table-column>
        <el-table-column prop="" width="75" label="现金流(万元)">
           <template scope="scope">
            <div>
              {{toFixed(scope.row.actualIncome-scope.row.actualExpense,4)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime"  width="150" :formatter="dateTimeFormat" label="编制时间"></el-table-column>
        <el-table-column prop="createUser" width="" label="编制人"></el-table-column>
        <el-table-column prop="auditTime" width="150" :formatter="dateTimeFormat" label="审核时间"></el-table-column>
        <el-table-column prop="auditUserName" width="" label="审核人"></el-table-column>
        <el-table-column prop="auditRemark" width="" label="审核备注"></el-table-column>
     </el-table>
   </div>
   <!-- 分页 -->
   <div>
     <el-pagination background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNo"
      :page-sizes="[25,50,100]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
     </el-pagination>
   </div>
    <weekPlanDialog v-if="dialogMonth" :dialogMonth.sync="dialogMonth" :rowData="rowData" :title="xzTitle" ></weekPlanDialog>
    <weekDetailDialog v-if="detailMark" :detailMark.sync="detailMark" :rowData="rowData" :title="xzTitle" ></weekDetailDialog>
    <weekShenheDialog v-if="shenheMark" :shenheMark.sync="shenheMark" :rowData="rowData"  ></weekShenheDialog>
 </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { weekMasterList, weeklySubmitForReview, weeklyReviewRevoke } from '@/api/common-signature'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import weekPlanDialog from '@/views/common-signature/fundingPlan/public/weekPlanDialog.vue'
import weekDetailDialog from '@/views/common-signature/fundingPlan/public/weekDetailDialog.vue'
import weekShenheDialog from '@/views/common-signature/fundingPlan/public/weekShenheDialog.vue'
export default {
  components: { weekPlanDialog, weekDetailDialog, weekShenheDialog },
  data () {
    return {
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      searchForm: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      tableList: [],
      userCode: localStorage.getItem('userCode'),
      isDisable: false,
      dialogMonth: false,
      xzTitle: '新增周资金计划',
      rowData: {},
      detailMark: false,
      shenheMark: false,
      orgSubCode: localStorage.getItem('orgSubCode'),
      btnFlg: [],
      btnIdArr: ['00FM0R0100', '00FM0R0200', '00FM0R0300', '00FM0R0400', '00FM0R0500', '00FM0R0600', '00FM0R0700', '00FM0R0800']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/weeklyFundPlan')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
    this.searchForm.monthlyPlanMasterId = this.$route.query.rowId
    this.searchForm.createDepartmentCode = this.$route.query.code
    this.searchForm.cycleDetailId = this.$route.query.zhouId
    this.getList()
  },
  methods: {
    // 撤销
    chexiaoFn  (row) {
      if (new Date().getTime() > row.weekSubmitPlanDate) {
        this.$message.error('撤销时间不能晚于最晚提交时间')
        return
      }
      this.$confirm('是否执行撤销操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        weeklyReviewRevoke({
          id: row.id
        })
          .then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList()
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      })
    },
    // 详情
    detailFn (row) {
      this.xzTitle = '周计划详情'
      this.rowData = row
      this.detailMark = true
    },
    // 审核
    shenheFn (row) {
      this.rowData = row
      this.shenheMark = true
    },
    // 编写
    bianXieFn (row) {
      if (new Date().getTime() > row.weekSubmitPlanDate) {
        this.$message.error('编辑时间不能晚于最晚提交时间')
        return
      }
      this.dialogMonth = true
      this.xzTitle = '新增周资金计划'
      this.rowData = row
    },
    editWeekFn (row) {
      if (new Date().getTime() > row.weekSubmitPlanDate) {
        this.$message.error('编辑时间不能晚于最晚提交时间')
        return
      }
      this.dialogMonth = true
      this.xzTitle = '修改周资金计划'
      this.rowData = row
    },
    shijishouzhiFn (row) {
      this.dialogMonth = true
      this.xzTitle = '实际收支'
      row.isSJ = true // 表示是实际收支
      row.isTZ = false // 表示是是否调整
      this.rowData = row
    },
    tiaozhengFn (row) {
      this.dialogMonth = true
      this.xzTitle = '调整'
      row.isTZ = true // 表示是是否调整
      row.isSJ = false // 表示是实际收支
      this.rowData = row
    },
    // 提交审核
    tijiaoFn (row) {
      if (new Date().getTime() > row.weekSubmitPlanDate) {
        this.$message.error('提交时间不能晚于最晚提交时间')
        return
      }
      this.$confirm('是否执行提交审核操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        weeklySubmitForReview({ id: row.id }).then(res => {
          this.getList()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    async daochuFn (row) {
      this.isDisable = true

      let form = { weeklyPlanMasterId: row.id }
      await exportExcel(
        this.global.smpName + '/weeklyFundPlanMaster/exportDetailList',
        form,
        '周资金计划明细'
      )
      this.isDisable = false
    },
    // 查选
    searchFn () {
      this.getList()
    },
    // 获取列表
    getList () {
      if (this.searchForm.createTime) {
        this.searchForm.startTime = this.searchForm.createTimes[0]
        this.searchForm.endTime = this.searchForm.createTimes[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
      this.loading = true
      weekMasterList(this.searchForm).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.loading = false
        if (this.$route.query.zhouId && this.$route.query.code) {
          this.detailFn(res.list[0])
        }
      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchForm = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.getList()
    }

  }
}
</script>

<style scoped lang='less'>
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
